import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import EducationMiddleware from './../../../modules/education/middleware'
import FilterAdvanced from './../../../components/Filter/FilterAdvanced'
import { addNotification as notify } from 'reapop'
import {paramsWarningNotify} from '../../../utils/notifyConfig'
import {filterLabels} from '../../../utils/filterLabels'

const mapStateToProps = ({education, units}) => ({
  filters: {
    intelligenceScopes: education.intelligenceScopes,
    onuGroups: education.onuGroups,
    onuGoals: education.onuGoals,
    twentyfirstCompetences: education.twentyfirstCompetences,
    twentyfirstSkills: education.twentyfirstSkills,
    oostSubjects: education.oostSubjects,
    sels: education.sels
  },
  currentUnit: units.currentItem
})

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    fetchIntelligenceScopes: () => EducationMiddleware.fetchIntelligenceScope(),
    fetchOnuGroups: () => EducationMiddleware.fetchOnuGroups(),
    fetchOnuGoals: (groupIds = []) => EducationMiddleware.fetchOnuGoals(groupIds),
    fetchTwentyfirstCompetences: () => EducationMiddleware.fetchTwentyfirstCompetences(),
    fetchTwentyfirstSkills: () => EducationMiddleware.fetchTwentyfirstSkills(),
    fetchOostSubjects: () => EducationMiddleware.fetchOostSubjects(),
    fetchSels: () => EducationMiddleware.fetchSels(),
    notify: () => (notify({
      ...paramsWarningNotify,
      message: 'Por favor, selecione uma escola.',
      status: 400}))
  }, dispatch)
}

class FilterAdvancedContainer extends Component {
  constructor (props) {
    super(props)
    this.state = {filterVisible: false}
  }

  componentDidMount () {
    const {
      fetchIntelligenceScopes,
      fetchOnuGroups,
      fetchOnuGoals,
      fetchTwentyfirstCompetences,
      fetchTwentyfirstSkills,
      fetchOostSubjects,
      fetchSels
    } = this.props
    fetchIntelligenceScopes()
    fetchOnuGroups()
    fetchOnuGoals()
    fetchTwentyfirstCompetences()
    fetchTwentyfirstSkills()
    fetchOostSubjects()
    fetchSels()
  }

  toggleFilter = () => {
    this.setState({filterVisible: !this.state.filterVisible})
  }

  clearFilter = () => {
    if (this.filterSelect) this.filterSelect.clearFilter()
  }

  componentDidUpdate (prevProps) {
    const {currentUnit} = this.props
    if (currentUnit.item === null && prevProps.currentUnit.item !== null) this.clearFilter()
  } 

  render () {
    const {
      filters,
      changeHandler,
      fetchOnuGoals,
      onuFilterDependence
    } = this.props
    const {filterVisible} = this.state
    let filtersMap = []

    // this is a work around. is needed refactoring the filter structure
    const onuGroupsChangeHandler = (type, activeIds) => {
      fetchOnuGoals(activeIds)
      changeHandler(type, activeIds)
    }

    let config = {
      intelligenceScopes: { changeHandler: changeHandler, disabled: false },
      onuGroups: { changeHandler: onuGroupsChangeHandler, disabled: false },
      onuGoals: { changeHandler: changeHandler, disabled: onuFilterDependence.length === 0 },
      twentyfirstCompetences: { changeHandler: changeHandler, disabled: false },
      twentyfirstSkills: { changeHandler: changeHandler, disabled: false },
      oostSubjects: { changeHandler: changeHandler, disabled: false },
      sels: { changeHandler: changeHandler, disabled: false }
    }
    // end of work around
    Object.keys(filters).forEach(filterName => {
      if (filters[filterName]) {
        filtersMap.push({
          type: filters[filterName],
          name: filterName,
          label: filterLabels[filterName],
          options: '220px',
          placeholder: `Selecione ${filterLabels[filterName]}`,
          disabled: config[filterName].disabled,
          changeHandler: config[filterName].changeHandler
        })
      }
    })
    return (
      <div>
        <span className='advanced-filter__toggle' onClick={this.toggleFilter}>{' Pesquisa avançada '}
          { !filterVisible
            ? <i className='fa fa-caret-down' aria-hidden='true'/>
            : <i className='fa fa-caret-right' aria-hidden='true'/>
          }
        </span>
        {filterVisible ? <FilterAdvanced
          filters={filtersMap}
          changeHandler={changeHandler}
          ref={(element) => { this.filterSelect = element }}
        /> : ''}
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FilterAdvancedContainer)



// WEBPACK FOOTER //
// ./src/containers/FilterContainers/Advanced/index.js